













import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "SaveDraftConfirm",
  components: { BaseButton, BaseConfirm },
  props: {
    show: { type: Boolean, required: true },
  },
});
